<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}}</span>
  <p-calendar class="input-control" [formControlName]="inputData.colName"></p-calendar>
</div>

<!-- DATE - NOTHING -->
<!-- time - [timeOnly]="true" -->
<!-- datetime - [showTime]="true" -->